import { render, staticRenderFns } from "./repeatedMappingTable.vue?vue&type=template&id=ddd5b00a&scoped=true&"
import script from "./repeatedMappingTable.vue?vue&type=script&lang=js&"
export * from "./repeatedMappingTable.vue?vue&type=script&lang=js&"
import style0 from "./repeatedMappingTable.vue?vue&type=style&index=0&lang=css&"
import style1 from "./repeatedMappingTable.vue?vue&type=style&index=1&id=ddd5b00a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd5b00a",
  null
  
)

export default component.exports